import { IApiLink } from "@/types";
import ProfitCenter, { IGetProfitCenterDto } from './ProfitCenter';
import { ApiLinkEntity, ApiLinkRel } from 'config/constants';

export interface IGetProfitCentersDto {
    entities: IGetProfitCenterDto[]
    links: IApiLink[]
}

export class ProfitCenters {
    items: ProfitCenter[]
    linkCreate?: IApiLink

    constructor(dto: IGetProfitCentersDto) {
        this.items = dto.entities.map((pcDto) => new ProfitCenter(pcDto))
        this.linkCreate = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.profitCenter && lnk.rel === ApiLinkRel.new)
    }
}
